import React from 'react';
import { useLanguage } from '../../i18n/useLanguage';
import { StaticPage } from '../StaticPage';
import { PrivacyContentDe } from './PrivacyContentDe';
import { PrivacyContentEn } from './PrivacyContentEn';

export const PrivacyPage: React.FC = () => {
  const { language } = useLanguage();
  return (
    <StaticPage titleKey="static.privacy">
      {language === 'de' ? <PrivacyContentDe /> : <PrivacyContentEn />}
    </StaticPage>
  );
};
